export default __webpack_public_path__ + "static/media/icon-instagram.ccb12974.svg";